import React from "react";
import { useSelector } from "react-redux";
import { selectPumps, selectPumpDetails, selectGeneralStation } from "../../../redux/selectors";
import useDerateCalc from "../../../functions/useDerateCalc";
import { getPumpDisplayLabel } from "../Mechanical/Pumps/pumpIdHelpers";


const PrintPumps = () => {
  const pumps = useSelector(selectPumps);
  const pumpDetails = useSelector(selectPumpDetails);
  const pumpGeneral = useSelector(selectGeneralStation);
  const elevationDerate = useDerateCalc();

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const groupedDetails = details.reduce((acc, detail) => {
      if (!acc[detail.Zone]) {
        acc[detail.Zone] = [];
      }
      acc[detail.Zone].push(detail);
      return acc;
    }, {});

    return (
      <div>
        {Object.keys(groupedDetails).map((zone, index) => {
          const zoneDetails = groupedDetails[zone];

          return (
            <div className="section" key={index}>
              <h3 className="print-zone-label">Zone: {zone}</h3>
              {zoneDetails.map((detail, idx) => (
                <div key={idx}>
                  <h4 className="text-center">{getPumpDisplayLabel(detail.PumpID)} Summary (Qty: {detail.Quantity})</h4>            
                  
                  <table className="table table-bordered full-width">
                    <thead>
                      <tr>
                        <th className="text-center">Pump Details</th>
                        <th className="text-center">Motor Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="col-md-6">
                          <table>
                            <tbody>
                              <tr><td><strong>Watertronics Part Number: </strong>{detail.PumpWatertronicsPartNumber}</td></tr>
                              <tr><td><strong>Manufacturer: </strong>{detail.PumpManufacturer}</td></tr>
                              <tr><td><strong>Model: </strong>{detail.PumpManufacturerModelNumber}</td></tr>
                              <tr><td><strong>Type: </strong>{detail.PumpType}</td></tr>
                              <tr><td><strong>Efficiency: </strong>{detail.PumpEfficiency}</td></tr>
                              <tr><td><strong>TDH: </strong>{detail.PumpTDH}</td></tr>
                              <tr><td><strong>Flow: </strong>{detail.PumpFlow}</td></tr>
                              <tr><td><strong>TPL: </strong>{detail.PumpTPL}</td></tr>
                              <tr><td><strong>Stages: </strong>{detail.PumpStages}</td></tr>
                              <tr><td><strong>RPM: </strong>{detail.PumpRPM}</td></tr>
                              <tr><td><strong>Discharge Size: </strong>{detail.PumpDischargeSize}</td></tr>
                              <tr><td><strong>Impeller Trim: </strong>{detail.PumpImpellerTrim}</td></tr>
                              <tr><td><strong>Temp Sensor: </strong>{detail.PumpTempSensor}</td></tr>
                            </tbody>
                          </table>
                        </td>
                        <td className="col-md-6">
                          <table>
                            <tbody>
                              <tr><td><strong>Watertronics Part Number: </strong>{detail.MotorWatertronicsPartNumber}</td></tr>
                              <tr><td><strong>Manufacturer: </strong>{detail.MotorManufacturer}</td></tr>
                              <tr><td><strong>Manufacturer Model Number: </strong>{detail.MotorManufacturerModelNumber}</td></tr>
                              <tr><td><strong>HP: </strong>{detail.MotorHP}</td></tr>
                              <tr><td><strong>Efficiency: </strong>{detail.MotorEfficiency}</td></tr>
                              <tr><td><strong>Enclosure: </strong>{detail.MotorEnclosure}</td></tr>
                              <tr><td><strong>Frame: </strong>{detail.MotorFrame}</td></tr>
                              <tr><td><strong>FLA: </strong>{detail.MotorFLA}</td></tr>
                              <tr><td><strong>Coupling Type: </strong>{detail.MotorCouplingType}</td></tr>
                              <tr><td><strong>Coupling Size: </strong>{detail.MotorCouplingSize}</td></tr>
                              <tr><td><strong>Winding Heaters: </strong>{detail.MotorWindingHeaters}</td></tr>
                              <tr><td><strong>Temp Switch: </strong>{detail.MotorTempSwitch}</td></tr>
                              <tr><td><strong>Vibration Sensor: </strong>{detail.MotorVibrationSensor}</td></tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2"><strong>Comments: </strong>{detail.Comments}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    );
  };

  const renderZoneDetails = (zone) => {
    const zonePumps = pumps.filter(pump => pump.Zone === zone);
    if (zonePumps.length === 0) {
      return null;
    }

    const zonePump = zonePumps[0];
    const jockeyPump = pumpDetails.find(detail => detail.PumpID === 'Jockey');
    const zoneGeneral = pumpGeneral.find(general => general.Zone === zone);

    return (
      <div className="section">
        <h3 className="print-zone-label">Zone: {zone}</h3>
        <table className="table table-bordered full-width">
          <tbody>
            <tr>
              <td className="col-md-6">
                <table>
                  <tbody>
                    <tr><td><strong>Power Configuration: </strong>{zoneGeneral.PowerConfiguration}</td></tr>
                    <tr><td><strong>SCCR Rating: </strong>{zoneGeneral.SCCRating}</td></tr>
                    <tr><td><strong>FCC Type: </strong>{zoneGeneral.FCCType}</td></tr>
                  </tbody>
                </table>
              </td>
              <td className="col-md-6">
                <table>
                  <tbody>
                    <tr><td><strong>Motor Efficiency For All Motors: </strong>{zonePump.MotorEfficiencyForAllMotors}</td></tr>
                    <tr><td><strong>Jockey Sequence: </strong>{jockeyPump ? jockeyPump.JockeySequence : 'N/A'}</td></tr>
                    <tr><td><strong>Discharge Head Material: </strong>{zonePump.DischargeHeadMaterial}</td></tr>
                    <tr><td><strong>Main Shaft Material: </strong>{zonePump.MainShaftMaterial}</td></tr>
                    <tr><td><strong>Main Check Valve Design: </strong>{zonePump.MainCheckValveDesign}</td></tr>
                    <tr><td><strong>Motor Elevation Derate: </strong> {elevationDerate}</td></tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div>
      <h2 className="print-section-header">Pumps Summary</h2>
      {renderZoneDetails(1)}
      {renderDetails(pumpDetails.filter(detail => detail.Zone === 1))}
      {renderZoneDetails(2)}
      {renderDetails(pumpDetails.filter(detail => detail.Zone === 2))}
    </div>
  );
};

export default PrintPumps;
